import {
  Directive, ElementRef, HostListener, Input 
} from '@angular/core';

@Directive({
  selector: '[appNoSpecialChar]'
})
export class NoSpecialCharDirective {
  @Input('appNoSpecialChar') mode: string = 'general';

  private regexPatterns = {
    general: /[+<>=@-]/g,
    email: /[+<>=]/g,
    address: /[^a-zA-Z0-9\s,.#'/&()-]/g
  };

  constructor(private el: ElementRef) {}

  @HostListener('input', ['$event'])
  onInputChange(event: KeyboardEvent) {
    const input = this.el.nativeElement;
    const value = input.value;
    let regex;

    if (this.mode === 'email') {
      regex = this.regexPatterns.email;
    } else if (this.mode === 'address') {
      regex = this.regexPatterns.address;
    } else {
      regex = this.regexPatterns.general;
    }

    input.value = value.replace(regex, '');
    event.preventDefault();
  }
}
